export default __webpack_public_path__ + "static/media/discover1.2468f6a1.png";